import React, { Component, Fragment } from 'react'
import { FormInput, FormPassword, FormSubmit } from '@myxplor/forms'
import PasswordPolicy from '../password-policy'
import HeadingRocket from '../heading-rocket'

class ChangePasswordView extends Component {
  render() {
    const {
      handleChange,
      handleSubmit,
      loading,
      errors = {},
      newPassword,
      prefilledUser,
    } = this.props
    
    return (
      <Fragment>
        <HeadingRocket>Change Password</HeadingRocket>

        <p>Want to change your password? Just enter your details below
         and we&#39;ll take care of that for you.</p>

        <form onSubmit={handleSubmit}>
          <fieldset>
            <FormInput
              label="Username or Email address"
              name="user"
              required={true}
              onChange={handleChange}
              errors={errors.user}
              loading={prefilledUser || loading}
              value={prefilledUser}
            />
          </fieldset>

          <fieldset>
            <FormPassword
              name="currentPassword"
              label="Current Password"
              required={true}
              onChange={handleChange}
              errors={errors.currentPassword}
              loading={loading}
            />

            <FormPassword
              name="newPassword"
              label="New Password"
              required={true}
              onChange={handleChange}
              errors={errors.newPassword}
              loading={loading}
            />
            <PasswordPolicy
              password={newPassword}
              errors={errors.passwordPolicy}
            />

            <FormPassword
              name="confirmPassword"
              label="Confirm New Password"
              required={true}
              onChange={handleChange}
              errors={errors.confirmPassword}
              loading={loading}
            />
          </fieldset>
          
          <FormSubmit
            loadingTitle="Changing your password"
            errors={errors.submit || errors.summary}
            loading={loading}
          >Change password</FormSubmit>
        </form>
      </Fragment>
    )
  }
}

export default ChangePasswordView



// WEBPACK FOOTER //
// ./src/change-password/view.jsx